<ng-select [items]="allItems" [bindLabel]="textFieldName" [bindValue]="valueFieldName"
    [groupBy]="groupFieldName?groupFieldName:undefined" [multiple]="true" [closeOnSelect]="false" [(ngModel)]="value"
    [required]="required" [placeholder]="placeholder"
    name="ng-select-with-select-all-and-checkbox-and-group"
    (change)="onSelectionChange()" class="custom-ng-select-with-select-all-and-checkbox-and-group"
    appearance="standard" required>
    <ng-template ng-label-tmp let-item="item" let-clear="clear">
        <div class="">
            <span class="ng-value-label">{{ item[textFieldName] }}</span>
            <span aria-hidden="true" class="ng-value-icon right" (click)="clear(item)" (keydown)="noop()">×</span>
        </div>
    </ng-template>
    <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
        @if(!groupFieldName || (groupFieldName && groupExpeansion[item[groupFieldName]])){
            <mat-checkbox id="item-{{index}}" [(checked)]="item$.selected" class="fids-primary-checkbox w-100" [ngClass]="{'m-l-35': groupFieldName}" >
                        {{item[textFieldName]}}</mat-checkbox>
        }
    </ng-template>
    <ng-template ng-header-tmp let-items="items" let-searchTerm="searchTerm">
    @if((items && items.length > 0) || !searchTerm){
        <mat-checkbox [(ngModel)]="isAllSelected" class="fids-primary-checkbox m-l-19 header-checkbox w-100" [indeterminate]="isIndeterminate"
            (change)="toggleSelectAll()" > Select All </mat-checkbox>
    }
</ng-template>
  <ng-template ng-optgroup-tmp let-item="item">
        <div class="group-header" >
            <span (click)="toggleGroup(item[groupFieldName])" class="expand-collapse-icon" (keydown)="noop()">
                <i class="material-icons" >{{item?( this.groupExpeansion[item[this.groupFieldName]] ? 'remove' : 'add' ):"remove"}}</i>
              <!-- {{item?( this.groupExpeansion[item[this.groupFieldName]] ? '-' : '+' ):"+"}} -->
            </span>
            <mat-checkbox  class="fids-primary-checkbox vertical-align-middle group-checkbox w-100" [indeterminate]="item && isIndetermediateGroup(item[groupFieldName])"
            [checked]="item && isAllSelectedGroup(item[groupFieldName])"
            (change)="selectUnselectGroup(item, $event.checked)"> {{ item && item[groupFieldName] }} </mat-checkbox>
      </div>
</ng-template>
</ng-select>